/**
 * @generated SignedSource<<92b2395ffed3cf27faccce9eed7f783d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreHomeDesktop_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly memberships: {
          readonly count: number;
          readonly " $fragmentSpreads": FragmentRefs<"StoreProductList_packageConnection">;
        } | null | undefined;
        readonly packages: {
          readonly count: number;
          readonly " $fragmentSpreads": FragmentRefs<"StoreProductList_packageConnection">;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductList_session">;
  readonly " $fragmentType": "StoreHomeDesktop_session";
};
export type StoreHomeDesktop_session$key = {
  readonly " $data"?: StoreHomeDesktop_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreHomeDesktop_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "assignable",
  "value": true
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v2 = {
  "kind": "Literal",
  "name": "saleAvailability",
  "value": "PUBLIC"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "StoreProductList_packageConnection"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreHomeDesktop_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StoreProductList_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "packageType",
                      "value": "STANDARD"
                    },
                    (v2/*: any*/)
                  ],
                  "concreteType": "PackageConnection",
                  "kind": "LinkedField",
                  "name": "packages",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": "packages(assignable:true,first:4,packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
                },
                {
                  "alias": "memberships",
                  "args": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "kind": "Literal",
                      "name": "packageType",
                      "value": "MEMBERSHIP"
                    },
                    (v2/*: any*/)
                  ],
                  "concreteType": "PackageConnection",
                  "kind": "LinkedField",
                  "name": "packages",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": "packages(assignable:true,first:4,packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "f50c15d995e21886ffbb1d1c18d1e2c5";

export default node;
